import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect'
import EditIcon from '@mui/icons-material/Edit';
import {
  ArrowForwardIosOutlined as ArrowForwardIosOutlinedIcon,
  MoreVertOutlined as MoreVertOutlinedIcon,
  Opacity,
}
  from '@mui/icons-material/';
import { UPDATE_STATE } from '../../actions/types'
import { updateAppState } from "../../actions/appstate";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import {
  Box
  , Container
  , Grid, Modal
  , Paper
  , Chip
  , Avatar
  , Button
  , TextField
  , CircularProgress
  , Alert
  , FormControl
  , Radio
  , RadioGroup
  , FormControlLabel
  , Checkbox
  , label
  , Accordion
  , AccordionDetails
  , AccordionSummary
  , Typography
  , List
  , ListSubheader
  , ListItem
  , ListItemButton
  , Divider
  , ListItemIcon
  , ListItemText
  , styles as styled,
  Badge,
  Select,
  MenuItem,
  Tooltip,
  Input,
  InputAdornment,
  IconButton,
  Autocomplete,
  Skeleton,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
}
  from '@mui/material/';
import './style.css';
import dataService from '../../services/data.service';
import { deepCopy } from '@firebase/util';

import Settings from "./index";
import { useLocation, useNavigate } from "react-router-dom";
import { clearAPIRegistryData, cleanIDB, getPropertiesByPortfolioId } from "../../app/util";
import DataService from "../../services/data.service";
import IndexedDBManager from "../../indexed-db/indexed-db";
// import Select, { components } from 'react-select';
// const { Option } = components;
import { infoIconWhite, checkedIcon, unCheckedIcon, infoIconGrey, } from "./PricingModal1/icons";
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbarsComponent, useOverlayScrollbars } from "overlayscrollbars-react";

import PortfolioHomePage from "./Portfolio/PortfolioHomePage";
import PortfolioDetailsPage from "./Portfolio/PortfolioDetailsPage";
import PortfolioDetailsReadOnlyPage from "./Portfolio/PortfolioDetailsReadOnlyPage";
import PortfolioDeleteModal from "./Portfolio/PortfolioDeleteModal";
import PortfolioLimitReachedModal from "./Portfolio/PortfolioLimitReachedModal";
import { callApiDirect } from '../../hooks/useFetchApi';
import { toast } from 'react-toastify';



function ProfileSettings(props) {
  const dispatch = useDispatch();
  const { app, auth } = useSelector(state => state);
  const { app_state, ui_state } = app.current_state;
  const { user, profile } = auth;
  const properties = profile.property_details;
  properties.sort((a, b) => a.name.localeCompare(b.name));
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [compState, setCompState] = useState({
    user_info: {},
    user_info_: {},
    time_zones: [],
    skip_keys: [],
    editing: '',
    delta: {},
    isProfileChanged: false,
    msgTimeout: 4000,
  });
  // debugger;
  const updateCompState = (key, value) => {
    let keys = key ? key.split('>') : [];
    //Handling single deptch key/value pairs
    if (keys[0] && !keys[1]) {
      compState[keys[0]] = value;
    }
    //Handling double deptch key/value pairs
    if (keys[0] && keys[1]) {
      compState[keys[0]] = compState[keys[0]] ? compState[keys[0]] : {};
      compState[keys[0]][keys[1]] = value;
    }
    // compState.isProfileChanged = true;
    setCompState((state) => {
      return { ...state, ...compState };
    });
  }

  useEffect(() => {
    let isSubscribed = true;

    //Getting user profile information
    dataService
      .getData({
        api: "users/info/",
        request: { method: 'GET' },
      })
      .then((rs) => {
        console.log("users/info", rs);
        if (rs.status === "success") {
          //Changing default property name into id
          let res = deepCopy(rs);
          res.default_property = profile.default_property_id;
          let selected_property = properties.filter(p => p.id === res.default_property);
          if (selected_property && selected_property.length > 0) {
            res.selected_property = selected_property[0];

          }
          updateCompState('user_info_', rs);
          updateCompState('user_info', res);
          // debugger;
        }
      }, (err) => {
        console.log("ratePushSchedules Error!");
      });

    //Getting timezone list
    dataService
      .getData({
        api: "users/common-timezones/",
        request: { method: 'GET' },
      })
      .then((rs) => {
        console.log("timezones", rs);
        if (rs.status === "success") {
          // debugger
          updateCompState('time_zones', rs.data);
        }
      }, (err) => {
        console.log("users/common-timezones failed!");
      });
    notificationOnload();
    return () => (isSubscribed = false);
  }, []);


  const { user_info } = compState;

  const handleSave = (params) => {
    // debugger;
    let { delta } = compState;
    let formData = new FormData();
    let deltaArray = Object.keys(delta);
    deltaArray.map((key) => {
      formData.append(key, delta[key]);
    });
    // formData.append('method', 'PUT');
    if (deltaArray.length) {
      updateCompState('request', 'loading');
      dataService
        .updateData({
          api: "users/edit-user/",
          request: { formData, method: 'PUT' }
        })
        .then((rs) => {
          updateCompState('request', '');

          if (rs.status === "success") {
            updateCompState('isProfileChanged', false);
            updateCompState('requestSuccess', true);
            updateCompState('requestMsg', "Data saved successfully!");

            //Updating app_state for default property id
            // debugger;
            if (delta.defaultProperty) {
              profile.default_property_id = delta.defaultProperty;
              dispatch({ type: "SYSTEM_SETTINGS_UPDATED", payload: profile });
            }

            setTimeout(() => {
              updateCompState('requestSuccess', false);
            }, compState.msgTimeout);

            // debugger;
          } else {
            updateCompState('request', '');
            updateCompState('requestError', true);
            updateCompState('requestMsg', "Data saving failed: " + rs.message);

            setTimeout(() => {
              updateCompState('requestError', false);
            }, compState.msgTimeout);
          }
        }, (err) => {
          // debugger
          updateCompState('request', '');
          updateCompState('requestError', true);
          updateCompState('requestMsg', "Data saving failed!");

          setTimeout(() => {
            updateCompState('requestError', false);
          }, compState.msgTimeout);

          console.log("ratePushSchedules Error!");
        });
    }

    // debugger;
  };

  const handleCancel = (params) => {
    // debugger
    let original = deepCopy(compState.user_info_);
    let default_property_id = profile.default_property_id;
    let selected_property = properties.filter(p => p.id === default_property_id);
    if (selected_property && selected_property.length > 0) {
      selected_property = selected_property[0];
      original.selected_property = selected_property;
    }
    updateCompState('user_info', original);
    updateCompState('isProfileChanged', false);
    // debugger;
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((prevExpanded) => !prevExpanded);
  };

  const navigate = useNavigate();
  const [refreshingData, setRefreshingData] = useState(false);
  const [refreshedData, setRefreshedData] = useState(false);
  const [pushNotificationState, setPushNotificationState] = useState(null);
  function goBackToDashboard() {
    dispatch(
      updateAppState("navigate_to_dashboard", {
        app_state: {
          data_load: true,
          kpi_load: true,
        },
        ui_state: {
          active_settings_menu: "",
          showspinner: true,
        },
      }, "settings_click")
    );
    navigate("/");
  }
  function refreshData() {
    cleanIDB();
    //reverting changes back
    let original = deepCopy(compState.user_info_);
    let default_property_id = profile.default_property_id;
    let selected_property = properties.filter(p => p.id === default_property_id);
    if (selected_property && selected_property.length > 0) {
      selected_property = selected_property[0];
      original.selected_property = selected_property;
    }
    updateCompState('user_info', original);
    updateCompState('isProfileChanged', false);

    const payload = {
      token_string: user.token_string,
      resourceId: app_state.property_id,
      resourceType: "property",
      targetCache: ["srr", "forecast", "otb"],
      operation: "flush",
    };
    setRefreshingData(true);
    notificationOnload();
    // debugger;
    DataService.getData({ api: "rms/properties/clear-cache/" + app_state.property_id + "/" + app_state.active_data_src.id + "/", request: { method: 'GET' } })
      .then((data) => {
        //Do some task here just after respons
        if (data.status === "success") {
          setRefreshedData(true);
          setRefreshingData(false);
          console.log("refreshData Success");
          setTimeout(() => {
            setRefreshedData(false);
            // window.location.reload();
          }, 2000);
          clearAPIRegistryData();
        } else {
          setRefreshingData(false);
          console.warn("refreshData Error, data could not refreshed");
          setTimeout(() => {
            setRefreshedData(false);
          }, 3000);
        }
      })
      .catch((err) => {
        setRefreshingData(false);
        setTimeout(() => {
          setRefreshedData(false);
        }, 3000);
      });
  }
  function notificationOnload() {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        setPushNotificationState(true);
      }
      else {
        setPushNotificationState(false);
      }
    }
    //setPushNotificationState('Notification' in window && Notification.permission === 'granted')
  }
  // function pushNotification() {
  //   if ('Notification' in window) {
  //     if (Notification.permission === 'granted') {
  //       setPushNotificationState(false);
  //       alert("NOOTIFICATION DISABLED!\nYou won't be able to receive push notifications fron LodgIQ.");
  //       // new Notification('Want to turn off notification?', {
  //       // body: 'Please change your browser notification permission to disable it.',
  //       // });
  //     }
  //     else if (Notification.permission === 'denied') {
  //       setPushNotificationState(false);
  //       alert("NOTIFICATIONS ARE BLOCKED!\nTo enable them, please update your browser's notification settings.");
  //     }
  //     else if (Notification.permission === 'default') {
  //       Notification.requestPermission()
  //         .then(permission => {
  //           if (permission === 'granted') {
  //             setPushNotificationState(true);
  //             alert("NOTIFICATION ENABLED!\nNow you are able to receive push notifications from LodgIQ.");
  //             // new Notification('Notification is Enabled', {
  //             // body: 'Now you are able to receive push notifications from LodgIQ.',
  //             // });
  //           }
  //           else if (permission === 'denied') {
  //             setPushNotificationState(false);
  //             alert("NOTIFICATION BLOCKED!\nYou won't be able to receive push notifications fron LodgIQ.");
  //           }
  //         });
  //     }
  //   }
  // }
  function pushNotification() {
    if ('Notification' in window) {
      if (Notification.permission === 'default') {
        Notification.requestPermission()
          .then(permission => {
            if (permission === 'granted') {
              setPushNotificationState(true);
              alert("NOTIFICATION ENABLED!\nNow you are able to receive push notifications from LodgIQ.");
              // new Notification('Notification is Enabled', {
              // body: 'Now you are able to receive push notifications from LodgIQ.',
              // });
            }
            else if (permission === 'denied') {
              setPushNotificationState(false);
              alert("NOTIFICATION BLOCKED!\nYou won't be able to receive push notifications fron LodgIQ.");
            }
          });
      }
    }
  }


  return (
    <div>

      <Box className='top-axn-bar-1'
      >
        <Tooltip title="Back to Dashboard" arrow followCursor >
          <Button
            size="medium"
            variant="contained"
            className='back-to-dash-btn'
            onClick={goBackToDashboard}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="16.001" viewBox="0 0 16.001 16.001">
              <g id="Group_2234" data-name="Group 2234" transform="translate(24154 19449)">
                <path id="Path_3278" data-name="Path 3278" d="M.889,0h8.3a.889.889,0,0,1,.889.889V9.482a.889.889,0,0,1-.889.889H.889A.889.889,0,0,1,0,9.482V.889A.889.889,0,0,1,.889,0Z" transform="translate(-24154 -19449)" fill="#606060" />
                <g id="Path_3279" data-name="Path 3279" transform="translate(-24142.74 -19449)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3280" data-name="Path 3280" transform="translate(-24142.74 -19443.371)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3283" data-name="Path 3283" transform="translate(-24142.74 -19437.74)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3281" data-name="Path 3281" transform="translate(-24154 -19437.74)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3282" data-name="Path 3282" transform="translate(-24148.369 -19437.74)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
              </g>
            </svg>
            <span className='back-to-dash-txt'>Back to Dashboard</span>
          </Button>
        </Tooltip>

        <Tooltip title="Refresh Data" >
          <box
            onClick={refreshData}
            size="medium"
            variant="contained"
            className='refresh-btn'
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="#00415F" viewBox="0 0 256 256"><path d="M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z"></path></svg>
          </box>
        </Tooltip>

        <Alert
          icon={false}
          sx={{
            display: refreshedData ? "block" : "none",
            position: "fixed",
            left: 0,
            fontSize: 17,
            textAlign: "center",
            borderRadius: 0,
            lineHeight: 1,
            bottom: 40,
            width: "100%",
            zIndex: 100,
            backgroundColor: "green.main",
            color: "white.main",
          }}
          severity="success"
        >
          Data refreshed successfully!
        </Alert>

      </Box>

      <Box className='top-axn-bar'>
        <Box className='breadcrumb' sx={{ color: 'white.main' }}>
          {/* <span className="breadcrum-inactive">Settings</span>
          <ArrowForwardIosOutlinedIcon className="breadcrum-inactive"
            sx={{ top: 3, position: "relative", height: 18 }}
          ></ArrowForwardIosOutlinedIcon>
          <span className="breadcrum-inactive">Profile Settings</span>
          <ArrowForwardIosOutlinedIcon className="breadcrum-inactive"
            sx={{ top: 3, position: "relative", height: 18 }}
          ></ArrowForwardIosOutlinedIcon>
          <span className="breadcrum-active">Profile</span> */}
          <span className="breadcrum-inactive">Settings/</span>
          <span className="breadcrum-inactive">Profile Settings/</span>
          <span className="breadcrum-active">Profile</span>
        </Box>
      </Box>

      <Box className="bgwhite main-scroll-wrap" sx={{ pl: 2, pr: 0, pb: 2 }}>

        <div className='profile-heading'>PROFILE</div>

        <Alert
          severity="success"
          sx={{
            mt: 1,
            mr: 2,
            display: compState.requestSuccess ? "flex" : "none",
          }}
        >
          {compState.requestMsg}
        </Alert>
        <Alert
          severity="error"
          sx={{
            mt: 1,
            mr: 2,
            display: compState.requestError ? "flex" : "none",
          }}
        >
          {compState.requestMsg}
        </Alert>

        <Grid container sx={{ pt: 0 }}>
          <Grid item md={9} sx={{ mr: 0, pr: 0, position: 'relative' }}>

            <Box className='profile-name'>

              <Grid container className='profile' >
                <Grid>
                  <item>
                    <Box className='profile-pic' style={{ background: compState.localProfilePic }}>
                      <div className='profile-bio'>
                        {!compState.localProfilePic && !user_info.profile_image_url && user.fullname && user.fullname[0]}
                        {compState.localProfilePath && user_info.profile_image_url && <Tooltip title={user.fullname} followCursor>
                          {<Avatar sx={{ width: 90, height: 90 }} title={user.fullname} src={compState.localProfilePath} />}
                        </Tooltip>}
                        {!compState.localProfilePath && user_info.profile_image_url && <Tooltip title={user.fullname} followCursor>
                          {<Avatar sx={{ width: 90, height: 90 }} title={user.fullname} src={user_info.profile_image_url} />}
                        </Tooltip>}
                      </div>
                      <div className="half-circle">
                        <Box sx={{ position: 'relative', height: 30, mt: -1 }}>
                          <CameraAltOutlinedIcon color='white' fontSize='large' sx={{ position: 'absolute', left: 25, top: 2, zIndex: 99 }}></CameraAltOutlinedIcon>
                          <Tooltip sx={{ cursor: 'pointer' }} title="Click to choose file" arrow followCursor>
                            <Input onChange={(e) => {
                              // debugger;
                              let files = e.nativeEvent.srcElement.files;
                              // var img = document.createElement("img");
                              var reader = new FileReader();
                              reader.onloadend = function () {
                                // img.src = reader.result;
                                // debugger;
                                let localFile = reader.result;
                                updateCompState('localProfilePath', localFile);
                                updateCompState('localProfilePic', files[0]);
                                updateCompState('isProfileChanged', true);
                                updateCompState('delta>profileImage', files[0]);
                              }
                              reader.readAsDataURL(files[0]);

                              // let fileName = files.name;
                              // updateCompState('localProfilePic', img);
                              // debugger;
                            }} type="file" className='select-profile-pic' name="profileImage" />
                          </Tooltip>
                        </Box>

                      </div>

                    </Box>
                    <Box sx={{ position: 'relative' }}>
                      {compState.localProfilePic && <Box sx={{ whiteSpace: 'nowrap', position: 'absolute', top: -3, color: "#ccc" }}>{compState.localProfilePic.name}</Box>}
                    </Box>
                  </item>
                </Grid>
                <Grid item className='username'>


                  {compState.editing === 'fullname' && <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
                    <Grid item>
                      <div className='fullname editable'>
                        <FormControl sx={{ mr: 1 }}>
                          <TextField className='first-name' type="text" size='small' variant='standard'
                            value={user_info.first_name}
                            // label="First Name"
                            onBlur={(e) => {
                              // debugger;
                              let value = e.target.value;
                              updateCompState('user_info>first_name', value);
                              updateCompState('editing', '');
                              updateCompState('delta>firstName', value);

                            }}
                            onChange={(e) => {
                              let value = e.target.value;
                              updateCompState('user_info>first_name', value);
                              updateCompState('isProfileChanged', true);
                            }} />
                        </FormControl>

                      </div>
                    </Grid>
                    <Grid item>
                      <div className='fullname editable'>
                        <FormControl sx={{}} label="Last Name">
                          <TextField className='last-name' size='small' variant='standard'
                            value={user_info.last_name}
                            // label="Last Name"
                            onBlur={(e) => {
                              updateCompState('editing', '');

                            }}
                            onChange={(e) => {
                              let value = e.target.value;
                              updateCompState('user_info>last_name', value);
                              updateCompState('isProfileChanged', true);
                              updateCompState('delta>lastName', value);
                            }}
                          />
                        </FormControl>
                      </div>
                    </Grid>
                  </Grid>
                  }
                  {compState.editing !== 'fullname' &&
                    <>
                      {/* {user_info.fullname} */}
                      {user_info.first_name}  {user_info.last_name}
                      <Box className='pencil-edit' sx={{ cursor: 'pointer', display: 'inline', ml: 1 }}>
                        <Tooltip title="Click to edit" sx={{ display: 'inline-block' }}>
                          <svg className='profile-edit-pencil-icon' onClick={() => updateCompState('editing', 'fullname')} xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>
                          {/* <EditIcon fontSize='18px' onClick={() => updateCompState('editing', 'fullname')} /> */}
                        </Tooltip>
                      </Box>
                    </>}

                </Grid>

              </Grid>

              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box><span className='main-label'>Title:</span></Box>
                </Grid>
                <Grid item>
                  <Box elevation={2}>
                    {compState.editing === 'designation' && <FormControl fullWidth sx={{ mr: 1, fontSize: 14 }}>
                      <TextField sx={{ 'input': { fontSize: 14 } }} className='view designation' type="text" size='small' variant='standard'
                        value={user_info.designation || 'Regional Director of Revenue'}
                        // label="First Name"
                        onBlur={(e) => {
                          let value = e.target.value;
                          updateCompState('user_info>designation', value);
                          updateCompState('editing', '');
                          updateCompState('delta>designation', value);
                        }}
                        onChange={(e) => {
                          let value = e.target.value;
                          user_info.designation = value;
                          updateCompState('user_info>designation', value);
                          updateCompState('isProfileChanged', true);
                        }} />
                    </FormControl>
                    }

                    {/* {compState.editing !== 'designation' && <div onClick={() => { updateCompState('editing', 'designation') }}>{user_info.designation || 'Regional Director of Revenue'}</div>} */}
                    {compState.editing !== 'designation' &&
                      <>{user_info.designation || 'Regional Director of Revenue'}
                        <Box className='pencil-edit' sx={{ cursor: 'pointer', display: 'inline', ml: 1 }}>
                          <Tooltip title="Click to edit" sx={{ display: 'inline-block' }}>
                            <svg className='profile-edit-pencil-icon' onClick={() => updateCompState('editing', 'designation')} xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>
                            {/* <EditIcon fontSize='18px' onClick={() => updateCompState('editing', 'designation')} /> */}
                          </Tooltip>
                        </Box>
                      </>}
                    {/* Regional Director of Revenue */}
                  </Box>
                </Grid>
              </Grid>

              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box><span className='main-label'>EMAIL:</span></Box>
                </Grid>
                <Grid item>
                  <Box>{user_info.email}</Box>
                </Grid>
              </Grid>

              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box><span className='main-label'>MOBILE:</span></Box>
                </Grid>
                <Grid item>
                  <Box>
                    {compState.editing === 'mobileNo' && <FormControl sx={{ mr: 1 }}>
                      <TextField className='view mobileNo' type="text" size='small' variant='standard'
                        value={user_info.mobile_no}
                        // label="First Name"
                        onBlur={(e) => {
                          let value = e.target.value;
                          updateCompState('user_info>mobile_no', value);
                          updateCompState('editing', '');
                          updateCompState('delta>mobileNo', value);
                        }}
                        onChange={(e) => {
                          let value = e.target.value;
                          user_info.mobile_no = value;
                          updateCompState('user_info>mobile_no', value);
                          updateCompState('isProfileChanged', true);
                        }} />
                    </FormControl>
                    }
                    {compState.editing !== 'mobileNo' &&
                      <>{user_info.mobile_no || 'Mobile No'}
                        <Box className='pencil-edit' sx={{ cursor: 'pointer', display: 'inline', ml: 1 }}>
                          <Tooltip title="Click to edit" sx={{ display: 'inline-block' }}>
                            <svg className='profile-edit-pencil-icon' onClick={() => updateCompState('editing', 'mobileNo')} xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>
                            {/* <EditIcon fontSize='18px' onClick={() => updateCompState('editing', 'mobileNo')} /> */}
                          </Tooltip>
                        </Box>
                      </>
                    }
                  </Box>
                </Grid>
              </Grid>

              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box><span className='main-label'>User Time Zone:</span></Box>
                </Grid>
                <Grid item>
                  <Box>
                    {compState.editing === 'timezone' && <FormControl className="rate-textfield" size="small">

                      <Select
                        sx={{ height: 30 }}
                        value={compState.user_info.timezone}
                        className="timezone-select"
                        onBlur={(e) => {
                          let value = e.target.value;
                          updateCompState('user_info>timezone', value);
                          updateCompState('editing', '');

                        }}
                        onClose={
                          () => {
                            updateCompState('editing', '');
                            updateCompState('delta>userTimezone', user_info.timezone);
                            updateCompState('isProfileChanged', true);

                          }
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          compState.userTimezone = value;
                          updateCompState("user_info>timezone", value);
                        }}
                      >
                        {compState.time_zones.map((timeZone) => {
                          return <MenuItem value={timeZone}>{timeZone}</MenuItem>
                        })}

                      </Select>
                    </FormControl>
                    }

                    {compState.editing !== 'timezone' &&
                      <>{user_info.timezone}
                        <Box className='pencil-edit' sx={{ cursor: 'pointer', display: 'inline', ml: 1 }}>
                          <Tooltip title="Click to edit" sx={{ display: 'inline-block' }}>
                            <svg className='profile-edit-pencil-icon' onClick={() => updateCompState('editing', 'timezone')} xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>
                            {/* <EditIcon fontSize='18px' onClick={() => updateCompState('editing', 'timezone')} /> */}
                          </Tooltip>
                        </Box>
                      </>}
                  </Box>

                </Grid>
              </Grid>

              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box><span className='main-label'>Default Property:</span></Box>
                </Grid>
                <Grid item>
                  <Box>
                    {compState.editing === 'defaultProperty' && <FormControl className="rate-textfield-2" size="small" sx={{ width: "50%", color: "#606060" }}>

                      {/* <Select
                        sx={{ height: 30 }}
                        value={user_info.selected_property}
                        className="timezone-select"
                        onBlur={(e) => {
                          let value = e.target.value;
                          updateCompState('user_info>defaultProperty', value);
                          updateCompState('editing', '');

                        }}
                        onClose={
                          () => {
                            updateCompState('editing', '');
                            updateCompState('isProfileChanged', true);
                          }
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          // debugger;
                          // compState.defaultProperty = value;
                          updateCompState("user_info>defaultProperty", value);
                          updateCompState("user_info>selected_property", value);
                          updateCompState('delta>defaultProperty', value.id);
                        }}
                      >
                        <div className='profile-property-search'>
                          <TextField
                            className='textfield'
                            fullWidth
                            placeholder="Search"
                            onChange={handleSearch}
                            value={searchQuery}
                            InputProps={{
                              startAdornment: (
                                <div style={{ marginRight: '8px', marginTop: '5px' }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="#606060"
                                    viewBox="0 0 256 256"
                                  >
                                    <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
                                  </svg>
                                </div>
                              ),
                            }}
                          />
                        </div>
                        {properti.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item.name}
                          </MenuItem>
                        ))}

                      </Select> */}

                      <Autocomplete
                        value={user_info.selected_property}
                        options={properties}
                        getOptionLabel={(option) => option.name}
                        sx={{ height: 30 }}
                        className="default-property-search"
                        onBlur={(e) => {
                          let value = e.target.value;
                          updateCompState('user_info>defaultProperty', value);
                          updateCompState('editing', '');
                        }}
                        onClose={() => {
                          updateCompState('editing', '');
                          updateCompState('isProfileChanged', true);
                        }}
                        onChange={(event, value) => {
                          if (value) {
                            updateCompState('user_info>defaultProperty', value.name);
                            updateCompState('user_info>selected_property', value);
                            updateCompState('delta>defaultProperty', value.id);
                          }
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />


                    </FormControl>
                    }

                    {compState.editing !== 'defaultProperty' &&
                      <>{user_info.selected_property && user_info.selected_property.name}
                        <Box className='pencil-edit' sx={{ cursor: 'pointer', display: 'inline', ml: 1 }}>
                          <Tooltip title="Click to edit" sx={{ display: 'inline-block' }}>
                            <svg className='profile-edit-pencil-icon' onClick={() => updateCompState('editing', 'defaultProperty')} xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>
                            {/* <EditIcon fontSize='18px' onClick={() => updateCompState('editing', 'defaultProperty')} /> */}
                          </Tooltip>
                        </Box>
                      </>}
                  </Box>

                </Grid>
              </Grid>

              {/* Default Mode */}
              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box>
                    <span className='main-label'>Default Mode:</span>
                  </Box>
                </Grid>
                <Grid item>
                  <Box sx={{ ml: 0 }}>
                    <Grid container>
                      <Grid item>
                        <FormControl sx={{ mt: 0.8 }}>
                          <RadioGroup className='radio-group'
                            aria-labelledby="demo-radio-buttons-group-label"
                            // defaultValue="Graph"
                            value={user_info.default_view}
                            name="radio-buttons-group"
                            row
                            onChange={(e) => {
                              // debugger;
                              const value = e.target.value.toLowerCase();
                              user_info.default_view = value;
                              updateCompState("user_info>default_view", value);
                              updateCompState('isProfileChanged', true);
                              updateCompState('delta>defaultView', value);
                            }}
                          >
                            <FormControlLabel value="chart" checked={user_info.default_view && user_info.default_view.toLowerCase() === 'chart'} className="graph" control={<Radio />} label="Chart" />
                            <FormControlLabel value="table" checked={user_info.default_view && user_info.default_view.toLowerCase() === 'table'} className='table' sx={{}} control={<Radio />} label="Table" />

                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/* Default View */}
              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box>
                    <span className='main-label'>Default View:</span>
                  </Box>
                </Grid>
                <Grid item>
                  <Box sx={{ ml: 0 }}>
                    <Grid container>
                      <Grid item>
                        <FormControl sx={{ mt: 0.8 }}>
                          <RadioGroup className='radio-group'
                            aria-labelledby="demo-radio-buttons-group-label"
                            // defaultValue="Graph"
                            value={user_info.ui_view_mode}
                            name="radio-buttons-group"
                            row
                            onChange={(e) => {
                              // debugger;
                              const value = e.target.value;
                              user_info.ui_view_mode = value;
                              updateCompState("user_info>ui_view_mode", value);
                              updateCompState('isProfileChanged', true);
                              updateCompState('delta>uiViewMode', value);
                            }}
                          >
                            <FormControlLabel value="Standard" checked={user_info.ui_view_mode && user_info.ui_view_mode === 'Standard'} className="Standard" control={<Radio />} label="Standard" />
                            <FormControlLabel value="Expanded" checked={user_info.ui_view_mode && user_info.ui_view_mode === 'Expanded'} className='Expanded' sx={{}} control={<Radio />} label="Expanded" />

                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/* data_view_mode below view code is not enable , do not remove dn class from first div */}
              <Grid container className='profile-info dn'>
                <Grid item sx={{}}>
                  <Box>
                    <span className='main-label'>View Mode:</span>
                  </Box>
                </Grid>
                <Grid item>
                  <Box sx={{ ml: 0 }}>
                    <Grid container>
                      <Grid item>
                        <FormControl sx={{ mt: 0.8 }}>
                          <RadioGroup className='radio-group'
                            aria-labelledby="demo-radio-buttons-group-label"
                            // defaultValue="Graph"
                            value={user_info.data_view_mode}
                            name="radio-buttons-group"
                            row
                            onChange={(e) => {
                              // debugger;
                              const value = e.target.value;
                              user_info.data_view_mode = value;
                              updateCompState("user_info>data_view_mode", value);
                              updateCompState('isProfileChanged', true);
                              updateCompState('delta>dataViewMode', value);
                            }}
                          >
                            <FormControlLabel value="Current Year" checked={user_info.data_view_mode && user_info.data_view_mode === 'Current Year'} className="Standard" control={<Radio />} label="Current Year" />
                            <FormControlLabel value="Rolling 12 Months" checked={user_info.data_view_mode && user_info.data_view_mode === 'Rolling 12 Months'} className='Expanded' sx={{}} control={<Radio />} label="Rolling 12 Months" />

                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/* LRV-880 Remove the class dn */}
              <Grid container className='profile-info dn'>
                <Grid item sx={{}}>
                  <Box>
                    <span className='main-label'>Default Comparison</span>
                  </Box>
                </Grid>
                <Grid item>
                  <Box sx={{ ml: 0 }}>
                    <Grid container>
                      <Grid item>
                        <FormControl sx={{ mt: 0.8 }}>
                          <RadioGroup className='radio-group'
                            aria-labelledby="comparison-buttons-group-label"
                            // defaultValue="Graph"
                            value={user_info.default_ly}
                            name="comparison-buttons-group"
                            row
                            onChange={(e) => {
                              debugger;
                              const value = e.target.value.toLowerCase();
                              user_info.default_ly = value;
                              updateCompState("user_info>default_ly", value);
                              updateCompState('isProfileChanged', true);
                              updateCompState('delta>defaultLy', value);
                            }}
                          >
                            <FormControlLabel value="sdly" checked={user_info.default_ly && user_info.default_ly.toLowerCase() === 'sdly'} className="sdly" control={<Radio />} label="Day" />
                            <FormControlLabel value="sdtly" checked={user_info.default_ly && user_info.default_ly.toLowerCase() === 'sdtly'} className='sdtly' sx={{}} control={<Radio />} label="Date" />

                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid container className='profile-info'>
                <Grid item sx={{}}>
                  <Box><span className='main-label'>Notification Preference:</span></Box>
                </Grid>
                <Grid item>
                  <Box>
                    <Grid container spacing={2}>
                      <Grid item sx={{ fontFamily: "SFUI Medium" }}>Notify me via..</Grid>

                      <Tooltip title={!(user_info && user_info.mobile_no && user_info.mobile_no.length >= 10) ? "Please enter valid mobile number" : ""} arrow followCursor >
                        <Grid item >
                          {compState.user_info.text_noti_subscribed &&
                            <Checkbox
                              checked={(user_info && user_info.mobile_no && user_info.mobile_no.length >= 10)}
                              disabled={!(user_info && user_info.mobile_no && user_info.mobile_no.length >= 10)}
                              onChange={(e) => {
                                const value = e.target.checked;
                                compState.user_info.text_noti_subscribed = value;
                                updateCompState("user_info>text_noti_subscribed", value);
                                updateCompState('delta>notificationPrefText', value);
                                updateCompState('isProfileChanged', true);
                              }} value={user_info.text_noti_subscribed} className='settting-profile-checkbox'
                            />
                          }
                          {!compState.user_info.text_noti_subscribed &&
                            <Checkbox
                              disabled={!(user_info && user_info.mobile_no && user_info.mobile_no.length >= 10)}
                              onChange={(e) => {
                                const value = e.target.checked;
                                compState.user_info.text_noti_subscribed = value;
                                updateCompState("user_info>text_noti_subscribed", value);
                                updateCompState('delta>notificationPrefText', value);
                                updateCompState('isProfileChanged', true);
                              }} value={user_info.text_noti_subscribed} className='settting-profile-checkbox'
                            />
                          }
                          <span style={!(user_info && user_info.mobile_no && user_info.mobile_no.length >= 10) ? { opacity: 0.4 } : {}}> Mobile</span>
                        </Grid>
                      </Tooltip>

                      <Grid item >
                        {compState.user_info.mail_noti_subscribed && <Checkbox
                          checked
                          onChange={(e) => {
                            // debugger;
                            const value = e.target.checked;
                            compState.user_info.mail_noti_subscribed = value;
                            updateCompState("user_info>mail_noti_subscribed", value);
                            updateCompState('delta>notificationPrefEmail', value);
                            updateCompState('isProfileChanged', true);
                          }} value={user_info.mail_noti_subscribed} className='settting-profile-checkbox' />
                        }
                        {!compState.user_info.mail_noti_subscribed && <Checkbox

                          onChange={(e) => {
                            // debugger;
                            const value = e.target.checked;
                            compState.user_info.mail_noti_subscribed = value;
                            updateCompState("user_info>mail_noti_subscribed", value);
                            updateCompState('delta>notificationPrefEmail', value);
                            updateCompState('isProfileChanged', true);
                          }} value={user_info.mail_noti_subscribed} className='settting-profile-checkbox' />
                        }
                        <span> Email</span>
                      </Grid>

                      <Grid item >
                        {console.log("pushNotificationState", compState.user_info.push_noti_subscribed)}

                        <Checkbox
                          //checked={pushNotificationState ? true : false}
                          checked={compState.user_info.push_noti_subscribed
                            ?
                            pushNotificationState ? true : false
                            :
                            false
                          }
                          onChange={(e) => {
                            const value = e.target.checked;
                            compState.user_info.push_noti_subscribed = value;
                            updateCompState("user_info>push_noti_subscribed", value);
                            updateCompState('delta>notificationPrefWeb', value);
                            updateCompState('isProfileChanged', true);
                            pushNotification();
                          }}
                          value={user_info.push_noti_subscribed}
                          className='settting-profile-checkbox'
                        />


                        <span> Push Notification</span>
                      </Grid>

                    </Grid>

                  </Box>
                </Grid>

              </Grid>

              <Box className='profile-buttons'>
                <Button
                  className='profile-cancel-btn'
                  disabled={!compState.isProfileChanged}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  className='profile-save-btn'
                  disabled={!compState.isProfileChanged}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </Box>

            </Box>

            <Box className={`profile-name change-pass ${isExpanded ? 'expanded' : ''}`} sx={{ pt: 0, pb: 0, m: 0 }}>
              <div>
                <Grid container>
                  <Grid item xs={12}>
                    <Box className='change-password'>
                      <Grid className='security-heading' container >
                        <Grid>
                          <div className='heading'>
                            {/* <div className={`security-icon ${isExpanded ? 'expanded' : ''}`}></div> */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#333333" viewBox="0 0 256 256"><path d="M128,112a28,28,0,0,0-8,54.83V184a8,8,0,0,0,16,0V166.83A28,28,0,0,0,128,112Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,128,152Zm80-72H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z"></path></svg>
                            Change Password
                          </div>
                        </Grid>
                        <Grid >
                          <svg
                            onClick={handleToggle}
                            className={`pass-change-icon ${isExpanded ? 'expanded' : 'collapsed'}`}
                            xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#333333" viewBox="0 0 256 256"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
                          </svg>
                        </Grid>
                      </Grid>
                      {isExpanded && <SecuritySettings />}
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </Box>

          </Grid>

          <Grid item md={3}>
            <Box className='profile-dashboard' sx={{ height: 'calc(100vh - 18vh)', overflow: 'hidden', ml: 0, }}>
              <div className='profile-side-head'>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#00415F" viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"></path></svg>
                <h3 className='profile-right-heading'>Access List</h3>
              </div>
              <Box sx={{ height: 'calc(100vh - 20vh)', overflow: 'auto', pb: 2, ml: 1, mr: 1 }}>
                <List sx={{ ml: 0, pl: 0 }}>
                  {
                    properties.map((item, index) => {
                      return (
                        <ListItem key={`item-${index}`} className="property-list">
                          <Box>
                            {!item.ea ? null :
                              <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1270_4391)">
                                  <path d="M9.18931 8.35988C9.08677 8.35988 8.98423 8.31988 8.91324 8.23988C8.75548 8.08788 8.75548 7.83188 8.91324 7.67188L11.4137 5.13588C11.4847 5.06388 11.5872 5.01588 11.6898 5.01588C11.7923 5.01588 11.8948 5.05588 11.9658 5.13588L13.1017 6.28788L15.3576 3.99988C15.5153 3.83988 15.7599 3.83988 15.9176 3.99988C16.0754 4.15988 16.0754 4.40788 15.9176 4.56788L13.3856 7.13588C13.2279 7.29588 12.9834 7.29588 12.8256 7.13588L11.6898 5.98388L9.47327 8.23988C9.3944 8.31988 9.29185 8.35988 9.1972 8.35988H9.18931Z" fill="#606060" />
                                  <path d="M5.7108 0.399902V4.1359H0.394409V1.8959C0.394409 1.0639 1.0491 0.399902 1.86154 0.399902H5.7108Z" fill="#F8F9FA" />
                                  <path d="M5.7108 4.13599H0.394409V7.86399H5.7108V4.13599Z" fill="#EBEBEB" />
                                  <path d="M5.7108 7.86401V11.6H1.86154C1.0491 11.6 0.394409 10.936 0.394409 10.104V7.86401H5.7108Z" fill="#B2B2B2" />
                                  <path d="M5.71078 0H1.86152C0.836109 0 0 0.848 0 1.896V10.104C0 11.152 0.836109 12 1.86152 12H5.71078C5.93164 12 6.10517 11.824 6.10517 11.6V0.4C6.10517 0.176 5.93164 0 5.71078 0ZM0.788782 4.536H5.31639V7.464H0.788782V4.536ZM0.788782 1.896C0.788782 1.288 1.26994 0.8 1.86152 0.8H5.31639V3.736H0.788782V1.896ZM5.31639 11.2H1.86152C1.26994 11.2 0.788782 10.712 0.788782 10.104V8.264H5.31639V11.2Z" fill="#606060" />
                                  <path d="M16.1385 12H6.97288C6.75202 12 6.57849 11.824 6.57849 11.6V0.4C6.57849 0.176 6.75202 0 6.97288 0H16.1385C17.1639 0 18.0079 0.848 18.0079 1.896V10.112C18.0079 11.152 17.1718 12.008 16.1385 12.008V12ZM7.36727 11.2H16.1385C16.7301 11.2 17.2192 10.712 17.2192 10.104V1.896C17.2192 1.296 16.738 0.8 16.1385 0.8H7.36727V11.2Z" fill="#606060" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1270_4391">
                                    <rect width="18" height="12" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            }
                          </Box>
                          <ListItemText primary={`${item.name}`} className="property-name" />
                          {/* <Chip className='property-role border' label="Revenue" variant="outlined" /> */}
                        </ListItem>

                      )
                    })
                  }
                </List>

              </Box>
            </Box>

          </Grid>

        </Grid >
        {
          compState.request === 'loading' && (
            <Box
              sx={{
                textAlighn: "center",
                backgroundColor: "dark.darkest",
                opacity: 0.8,
                position: "fixed",
                top: 40,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 100,
              }}
            >
              <CircularProgress
                size={40}
                sx={{
                  color: "white",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-20px",
                  marginLeft: "-20px",
                }}
              />
            </Box>
          )
        }
      </Box >

      {refreshingData && (
        <Box
          sx={{
            textAlighn: "center",
            backgroundColor: "dark.darkest",
            opacity: 0.8,
            position: "fixed",
            top: 40,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 100,
          }}
        >
          <CircularProgress
            size={40}
            sx={{
              color: "white",
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-20px",
              marginLeft: "-20px",
            }}
          />
        </Box>
      )}

    </div >
  );
}

function SecuritySettings(props) {
  const dispatch = useDispatch();
  const { app, auth } = useSelector(state => state);
  const { user, profile } = auth;
  const properties = profile.property_details;
  const [formData, setFormData] = useState({ old_pass: '', new_pass: '', repeat_pass: '', submitDisabled: true });
  const [errorType, setErrorType] = useState("");
  const [isrequesting, setIsRequesting] = useState(false);
  const [resError, setResError] = useState(false);
  const [isRequestSuccess, setIsRequestSuccess] = useState(false);
  const [requestSuccessMsg, setRequestSuccessMsg] = useState('Your request for change password was successfull!');
  const [isRequestError, setIsRequestError] = useState(false);
  const [resErrorMsg, setResErrorMsg] = useState('');

  useEffect(() => {
    const { old_pass, new_pass, repeat_pass, submitDisabled } = formData;
    if (old_pass && new_pass && repeat_pass && (new_pass === repeat_pass)) {
      //setFormData({...formData, submitDisabled:false});
    } else {
      //setFormData({...formData, submitDisabled:true});
    }
  }, [formData]);
  const checkValidity = () => {
    const { old_pass, new_pass, repeat_pass } = formData;

    if (old_pass && new_pass && repeat_pass && (new_pass === repeat_pass)) {
      setFormData({ ...formData, submitDisabled: false });
    }
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    const { old_pass, new_pass } = formData;
    setIsRequesting(true);
    let payload = {
      password: {
        old: old_pass,
        new: new_pass
      }
      // "current_password": old_pass,
      // "new_password": new_pass,
      // "email": user.email,
      // "token_string": user.token_string,
      // "user_id": user.user_id
    }
    dataService.update({ api: 'users/change-password', request: payload })
      .then(
        (data) => {
          //Do some task here just after respons
          if (data.status === "success") {
            setIsRequestSuccess(true);
            setIsRequesting(false);
            setFormData({ old_pass: '', new_pass: '', repeat_pass: '', submitDisabled: true });
            setTimeout(() => {
              setIsRequestSuccess(false);
              sessionStorage.clear();
              localStorage.clear();
            }, 3000);
            //return Promise.resolve(data);
          }
          else {
            setIsRequestError(true);
            setIsRequesting(false);
            setResErrorMsg(data.message);
            //return Promise.reject(data);
          }
        }
      )
      .catch((err) => {
        setIsRequestError(true);
        setResErrorMsg(err.original.statusText || 'Something went wrong, please try again later!');
        return Promise.reject(err);
      })
  }
  function updateRequestData(e, type) {
    formData[type] = e.target.value;
    //setFormData({...formData});
    const { old_pass, new_pass, repeat_pass } = formData;
    if (new_pass && repeat_pass && (new_pass !== repeat_pass)) {
      setIsRequestError(true);
      setResErrorMsg("New password and repeated password is not matching, please check and try again");
    } else {
      setIsRequestError(false);
      setResErrorMsg("");
    }
    if (old_pass && new_pass && repeat_pass && (new_pass === repeat_pass)) {
      setFormData({ ...formData, submitDisabled: false });
    } else {
      setFormData({ ...formData, submitDisabled: true });
    }
  }


  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRenewPassword, setShowRenewPassword] = useState(false);

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleRenewPasswordVisibility = () => {
    setShowRenewPassword(!showRenewPassword);
  };


  return (
    <>
      <Grid container spacing={3}>

        <Grid item md={12} sx={{ mr: 0, pr: 0 }}>
          <Box sx={{ pt: 2 }}>
            <Box sx={{ display: isRequestSuccess ? 'block' : 'none', p: 1, position: 'relative', color: 'white.main', backgroundColor: 'green.green', textAlign: 'center', fontSize: 17 }}>
              {requestSuccessMsg}
            </Box>
            <Alert severity="error" sx={{ display: isRequestError ? 'flex' : 'none' }}>{resErrorMsg}</Alert>
            <Box className='pass-change-form' component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 0, padding: 1, }}>

              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        paddingRight: 0,
                      },
                    }}
                    className='textfield'
                    size='small'
                    error={errorType === "password"}
                    helperText={errorType === "password" ? "Invalid password" : ""}
                    margin="normal"
                    required
                    fullWidth
                    id="old_password"
                    label="Old Password"
                    type={showPassword ? 'text' : 'password'}
                    name="old_password"
                    autoComplete=""
                    value={formData.old_pass}
                    onChange={(e) => {
                      updateRequestData(e, 'old_pass');
                      //setFormData({...formData, old_pass:e.target.value});
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton onClick={handlePasswordVisibility}>
                            {showPassword ? <i class="ph ph-eye"></i> : <i class="ph ph-eye-closed"></i>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    autoFocus
                  />

                </Grid>
                <Grid item xs={4}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        paddingRight: 0,
                      },
                    }}
                    className='textfield'
                    size='small'
                    margin="normal"
                    error={errorType === "password"}
                    helperText={errorType === "password" ? "Invalid password" : ""}
                    required
                    fullWidth
                    name="new_pass"
                    label="New Password"
                    type={showNewPassword ? 'text' : 'password'}
                    id="new_password"
                    autoComplete=""
                    value={formData.new_pass}
                    onChange={(e) => {
                      updateRequestData(e, 'new_pass');
                      //setFormData({...formData, new_pass:e.target.value});
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton onClick={handleNewPasswordVisibility}>
                            {showNewPassword ? <i class="ph ph-eye"></i> : <i class="ph ph-eye-closed"></i>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        paddingRight: 0,
                      },
                    }}
                    className='textfield'
                    size='small'
                    margin="normal"
                    error={errorType === "password"}
                    helperText={errorType === "password" ? "Invalid password" : ""}
                    required
                    fullWidth
                    name="repeat_pass"
                    label="Repeat New Password"
                    type={showRenewPassword ? 'text' : 'password'}
                    id="repeat_pass"
                    autoComplete=""
                    value={formData.repeat_pass}
                    onChange={(e) => {
                      updateRequestData(e, 'repeat_pass');
                      //setFormData({...formData, repeat_pass:e.target.value});

                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton onClick={handleRenewPasswordVisibility}>
                            {showRenewPassword ? <i class="ph ph-eye"></i> : <i class="ph ph-eye-closed"></i>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <div className='profile-change-password-btn-parent' >
                  <Button
                    className='profile-change-password-btn'
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={formData.submitDisabled}
                    sx={{ mr: 1, mt: 2, mb: 0, backgroundColor: 'green.main', fontSize: 14, color: '#fff', '&:disabled': { backgroundColor: '#333333', color: '#fff', opacity: 0.4, cursor: 'not-allowed' }, '&:hover': { backgroundColor: '#333333', opacity: 1 } }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>

              </Grid>

              {isrequesting && (
                <Box sx={{ textAlighn: 'center', backgroundColor: 'dark.darkest', opacity: 0.8, position: 'absolute', top: 40, left: 0, width: '100%', height: '100%', zIndex: 100 }}>
                  <CircularProgress
                    size={40}
                    sx={{
                      color: 'white',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-20px',
                      marginLeft: '-20px',
                    }}
                  />
                </Box>

              )}

            </Box>
          </Box>
        </Grid>

      </Grid>
    </>

  );
}

function PortfolioSettings(props) {
  const dispatch = useDispatch();
  const { app, auth } = useSelector(state => state);
  const { app_state, ui_state } = app.current_state;
  const { user, profile } = auth;
  const { user_login_type } = user;
  const properties = profile.property_details;
  properties.sort((a, b) => a.name.localeCompare(b.name));
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [isLoading, setIsLoading] = useState(true);
  const [isShowDetails, setIsShowDetails] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showLimitReachedPopup, setShowLimitReachedPopup] = useState(false);
  const [isReadOnlyDetails, setIsReadOnlyDetails] = useState(false);

  const navigate = useNavigate();
  const [refreshingData, setRefreshingData] = useState(false);
  const [refreshedData, setRefreshedData] = useState(false);
  const [pushNotificationState, setPushNotificationState] = useState(null);

  const [isShakeButton, setIsShakeButton] = useState(false);
  const [isrequesting, setIsRequesting] = useState(false);
  const [isChangeRequest, setIsChangeRequest] = useState(false);
  const [isCancelActive, setIsCancelActive] = useState(false);
  localStorage.setItem('isChanged', isChangeRequest);
  const refreshDataBtnAccess = [0, 1, 2, 3, 4, 5];
  const [nameError, setNameError] = useState("");
  const [isRequestError, setIsRequestError] = useState(false);

  const [maxPortfolioLimit, setMaxPortfolioLimit] = useState(3);

  useEffect(() => {
    dispatch(
      updateAppState("navigate_to_dashboard", {
        ui_state: {
          openSupport: false
        },
      }, "settings_click")
    );
  }, [])
  function openRequestSupport() {
    dispatch(
      updateAppState("support_open", {
        ui_state: {
          openSupport: true
        },
      }, "settings_click")
    );
    setShowLimitReachedPopup(false);
  }

  function goBackToDashboard() {
    if (isChangeRequest) {
      setIsShakeButton(true);
      setIsRequestError(true);
      let shakeAlert = document.getElementsByClassName("save-changes-alert");
      if (shakeAlert.length > 0) {
        shakeAlert[0].className = shakeAlert[0].className.replace("display-none", "").trim();
        setTimeout(() => {
          shakeAlert[0].className += " display-none";
        }, 2000);
      }
      setTimeout(function () {
        setIsShakeButton(false);
        // setIsRequestError(false);
      }, 3000); // 3000 milliseconds = 3 seconds
      return;
    }
    dispatch(
      updateAppState("navigate_to_dashboard", {
        app_state: {
          data_load: true,
          kpi_load: true,
        },
        ui_state: {
          active_settings_menu: "",
          showspinner: true,
        },
      }, "settings_click")
    );
    navigate("/");
  }

  function refreshData() {
    if (isChangeRequest) {
      setIsShakeButton(true);
      let shakeAlert = document.getElementsByClassName("save-changes-alert");
      if (shakeAlert.length > 0) {
        shakeAlert[0].className = shakeAlert[0].className.replace("display-none", "").trim();
        setTimeout(() => {
          shakeAlert[0].className += " display-none";
        }, 2000);
      }
      setTimeout(function () {
        setIsShakeButton(false);
      }, 2000); // 3000 milliseconds = 3 seconds
      return;
    }
    cleanIDB();
    //reverting changes back
    setIsChangeRequest(false);

    const payload = {
      token_string: user.token_string,
      resourceId: app_state.property_id,
      resourceType: "property",
      targetCache: ["srr", "forecast", "otb"],
      operation: "flush",
    };
    setRefreshingData(true);
    // debugger;
    DataService.getData({ api: "rms/properties/clear-cache/" + app_state.property_id + "/" + app_state.active_data_src.id + "/", request: { method: 'GET' } })
      .then((data) => {
        //Do some task here just after respons
        if (data.status === "success") {
          setRefreshedData(true);
          setRefreshingData(false);
          console.log("refreshData Success");
          setTimeout(() => {
            setRefreshedData(false);
            // window.location.reload();
          }, 2000);
          clearAPIRegistryData();
        } else {
          setRefreshingData(false);
          console.warn("refreshData Error, data could not refreshed");
          setTimeout(() => {
            setRefreshedData(false);
          }, 3000);
        }
      })
      .catch((err) => {
        setRefreshingData(false);
        setTimeout(() => {
          setRefreshedData(false);
        }, 3000);
      });
  }


  const [initialPortfolios, setInitialPortfolios] = useState(null);
  const getUserPortfolio = async () => {
    try {
      let payload = {};
      const result = await callApiDirect(app_state, "getUserPortfolio", payload, "GET");
      const { isSuccess } = result.data;
      if (isSuccess) {
        const portfolios = (result?.data?.data?.data?.portfolios ?? []).map(portfolio => ({
          ...portfolio,
          hotelIds: portfolio.properties?.map(p => p.property_id) ?? []
        }));
        setMaxPortfolioLimit(result?.data?.data?.data?.portfolio_count ?? 0);
        setPortfolios(portfolios);
        setInitialPortfolios(portfolios);
        setIsLoading(false);
      } else {
        console.error("Error deleting cart.");
      }
    } catch (error) {
      console.error("Error deleting cart items:", error);
    }
  };

  const [portfolios, setPortfolios] = useState(null);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const selectedHotelIds = selectedPortfolio?.hotelIds || [];
  let hotelsData = getPropertiesByPortfolioId(portfolios, '');
  const { selectedHotels, availableHotels } = useMemo(() => {
    const ids = selectedPortfolio?.hotelIds || [];
    return {
      selectedHotels: hotelsData.filter(h => ids.includes(h.property_id)),
      availableHotels: hotelsData.filter(h => !ids.includes(h.property_id)),
    };
  }, [selectedPortfolio, hotelsData]);

  const [checkedLeft, setCheckedLeft] = useState([]);   // hotel ids
  const [checkedRight, setCheckedRight] = useState([]); // hotel ids

  const handleLeftCheck = (id) => {
    setCheckedLeft(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
    setCheckedRight([]);
  };

  const handleRightCheck = (id) => {
    setCheckedRight(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
    setCheckedLeft([]);
  };


  const hasPortfolioChanged = (initial, selectedPortfolio, updatedHotelIds) => {
    const original = initial.find(p => p.id === selectedPortfolio.id);
    if (!original) return false;

    //  Name comparison
    const isNameChanged = original.name !== selectedPortfolio.name;

    //  HotelIds comparison (order independent)
    const originalIds = [...(original.hotelIds ?? [])].sort();
    const newIds = [...(updatedHotelIds ?? [])].sort();

    const isHotelIdsChanged =
      originalIds.length !== newIds.length ||
      !originalIds.every((id, index) => id === newIds[index]);

    return isNameChanged || isHotelIdsChanged;
  };


  const handleAdd = () => {
    const updatedHotelIds = [
      ...selectedHotelIds,
      ...checkedLeft
    ];
    setSelectedPortfolio(prev => ({
      ...prev,
      hotelIds: updatedHotelIds
    }));

    setCheckedLeft([]); // clear selection
    if (updatedHotelIds.length >= 2) {
      if (selectedPortfolio.name !== '' && !nameError) {
        setIsChangeRequest(true);
      }
    } else {
      toast.dismiss();
      toast.success("Please, Add at Least Two Hotels to create a Portfolio", {
        position: "bottom-right",
        autoClose: 3000,
        closeButton: false,
      });
    }
  };

  const handleRemove = () => {
    const updatedHotelIds = selectedHotelIds.filter(
      id => !checkedRight.includes(id)
    );

    setSelectedPortfolio(prev => ({
      ...prev,
      hotelIds: updatedHotelIds
    }));
    let changed = hasPortfolioChanged(initialPortfolios, selectedPortfolio, updatedHotelIds);
    setCheckedRight([]); // clear selection
    if (updatedHotelIds.length >= 2) {
      if (selectedPortfolio.name !== '' && changed) {
        setIsChangeRequest(true);
      }
      if (!changed) {
        setIsCancelActive(false);
        setIsChangeRequest(false);
      }
    } else {
      if (changed) {
        setIsCancelActive(true);
      }
      setIsChangeRequest(false);
      toast.dismiss();
      toast.success("Please select at least two hotels to create a portfolio.", {
        position: "bottom-right",
        autoClose: 3000,
        closeButton: false,
      });
    }
  };

  const handleSelectAllLeft = (properties) => {
    if (checkedLeft.length === availableHotels.length) {
      // Uncheck all
      setCheckedLeft([]);
    } else {
      // Check selected all
      // setCheckedLeft(availableHotels.map(h => h.property_id));
      const propertyIds = properties.map(item => item.property_id);
      setCheckedLeft(propertyIds);
      setCheckedRight([])
    }
  };

  const handleSelectAllRight = (properties) => {
    if (checkedRight.length === selectedHotels.length) {
      setCheckedRight([]);
    } else {
      setCheckedLeft([]);
      const propertyIds = properties.map(item => item.property_id);
      setCheckedRight(propertyIds);
      // setCheckedRight(selectedHotels.map(h => h.property_id));
    }
  };



  const handleCardClick = (id) => {
    let selectedPropertiesIds = getPropertiesByPortfolioId(portfolios, id, "id_only");
    let selected_portfolio = getPropertiesByPortfolioId(portfolios, id, "selected_portfolio");
    setSelectedPortfolio(selected_portfolio);
    if (selected_portfolio?.name === "All Hotels") {
      setIsShowDetails(true);
      setIsReadOnlyDetails(true)
    } else {
      setIsShowDetails(true);
      setIsReadOnlyDetails(false)
    }
    setCheckedRight([])
    setCheckedLeft([])
    setNameError("");
  };

  const handleBackButton = () => {
    //setIsShowDetails(false);
    if (isChangeRequest || isCancelActive) {
      setIsShakeButton(true);
      setIsRequestError(true);
      let shakeAlert = document.getElementsByClassName("save-changes-alert");
      if (shakeAlert.length > 0) {
        shakeAlert[0].className = shakeAlert[0].className.replace("display-none", "").trim();
        setTimeout(() => {
          shakeAlert[0].className += " display-none";
        }, 2000);
      }
      setTimeout(function () {
        setIsShakeButton(false);
        // setIsRequestError(false);
      }, 3000); // 3000 milliseconds = 3 seconds
      return;
    }
    cancelSave();
    setIsShowDetails(false);
    setIsReadOnlyDetails(false)
    setCheckedRight([])
    setCheckedLeft([]);
    setNameError("");

  };

  const handleAddNewPortfolio = () => {
    // Optional: limit check
    if (portfolios?.length >= maxPortfolioLimit) {
      setShowLimitReachedPopup(true);
      return;
    }

    const newPortfolio = {
      id: `temp-${Date.now()}`,
      name: "",
      properties: [],
      hotelIds: [],
      isNew: true,
    };

    setPortfolios(prev => [...prev, newPortfolio]);
    setSelectedPortfolio(newPortfolio);
    setIsShowDetails(true);
    //setIsChangeRequest(true);
  };

  const [selectedPortfolioDeleteId, setSelectedPortfolioDeleteId] = useState(null);
  const handleDeletePortfolio = (e, id) => {
    setSelectedPortfolioDeleteId(id);
    e.stopPropagation();
    setShowDeletePopup(true);
  };

  const confirmDeletePortfolio = async () => {
    try {
      let selected_portfolio = getPropertiesByPortfolioId(portfolios, selectedPortfolioDeleteId, "selected_portfolio");
      const payload = { id: selectedPortfolioDeleteId, is_active: false };
      const result = await callApiDirect(app_state, "getUserPortfolio", payload, "DELETE");
      const { isSuccess } = result.data;
      if (isSuccess) {
        // Remove deleted portfolio 
        setPortfolios(prev =>
          prev.filter(p => p.id !== selectedPortfolioDeleteId)
        );
        setInitialPortfolios(prev =>
          prev.filter(p => p.id !== selectedPortfolioDeleteId)
        );
        setShowDeletePopup(false);
        setSelectedPortfolioDeleteId(null);

        // generate the toast message
        let deleteMessage = selected_portfolio?.name + " has been successfully deleted."
        // let deleteMessage = "<span><strong>" + selected_portfolio?.name + "</strong> Sell Rate Recalibration Completed. Recommendations Are Now up to Date</span>";
        toast.dismiss();
        // toast.success(<span><strong>{selected_portfolio?.name}</strong> deleted successfully</span>, {
        toast.success(deleteMessage, {
          position: "bottom-right",
          autoClose: 3000,
          closeButton: false,
        });
        // toast.success(deleteMessage, {
        //   position: "bottom-right"
        // });
      } else {
        console.error("Delete failed");
      }
    } catch (error) {
      console.error("Error deleting portfolio:", error);
    }
  };

  const closeDeletePopup = () => {
    setSelectedPortfolioDeleteId(null);
    setShowDeletePopup(false);
  };

  const closeLimitReachedPopup = () => {
    setShowLimitReachedPopup(false);
  };

  // const handleDefaultPortfolio = (e, id) => {
  //   debugger;
  //     setSelectedPortfolioDeleteId(id);
  //     e.stopPropagation();
  //     makeDefaultPortfolio();
  //   };
  const handleDefaultPortfolio = async (e, id) => {
    e.stopPropagation();
    try {
      let selected_portfolio = getPropertiesByPortfolioId(portfolios, id, "selected_portfolio");
      let is_already_default = (selected_portfolio.name === 'All Hotels' && selected_portfolio.is_default) ? true : false;
      if (is_already_default) {
        toast.dismiss();
        toast.success("At least one portfolio must be set as the default.", {
          position: "bottom-right",
          autoClose: 3000,
          closeButton: false,
        });
        return false;
      }
      const payload = { id: id, is_default: !selected_portfolio.is_default, name: selected_portfolio.name, properties: selected_portfolio.hotelIds };
      const result = await callApiDirect(app_state, "getUserPortfolio", payload, "PUT");
      const { isSuccess } = result.data;
      if (isSuccess) {
        const portfolios = (result?.data?.data?.data?.portfolios ?? []).map(portfolio => ({
          ...portfolio,
          hotelIds: portfolio.properties?.map(p => p.property_id) ?? []
        }));
        setPortfolios(portfolios);
        setInitialPortfolios(portfolios);
        setIsLoading(false);
        let defaultMessage = (!selected_portfolio.is_default) ? selected_portfolio.name + " is set to your default portfolio" : "All Hotels is set to your default portfolio";
        toast.dismiss();
        toast.success(defaultMessage, {
          position: "bottom-right",
          autoClose: 3000,
          closeButton: false,
        });
      } else {
        console.error("Error deleting cart.");
      }
    } catch (error) {
      console.error("Error deleting portfolio:", error);
    }
  };


  // Save Changes
  const saveChanges = async () => {

    if (!selectedPortfolio) return;

    setIsRequesting(true);

    try {
      let payload = {
        name: selectedPortfolio.name,
        properties: selectedPortfolio.hotelIds
      };
      let result = null;
      // let msg = selectedPortfolio.name + " has been successfully created/updated. Please allow up to 5 minutes for the changes to reflect in Portfolio Analytics.";
      const action = selectedPortfolio.isNew ? "created" : "updated";
      let msg = `${selectedPortfolio.name} has been successfully ${action}. Please allow up to 5 minutes for the changes to reflect in Portfolio Analytics.`;

      const method = selectedPortfolio.isNew ? "POST" : "PUT";
      if (!selectedPortfolio.isNew) {
        payload.id = selectedPortfolio.id;
      }
      result = await callApiDirect(app_state, "getUserPortfolio", payload, method);

      const { isSuccess } = result.data;
      if (isSuccess) {
        const portfolios = (result?.data?.data?.data?.portfolios ?? []).map(portfolio => ({
          ...portfolio,
          hotelIds: portfolio.properties?.map(p => p.property_id) ?? []
        }));
        setPortfolios(portfolios);
        setInitialPortfolios(portfolios);
        setIsLoading(false);

        toast.dismiss();
        toast.success(msg, {
          position: "bottom-right",
          autoClose: 3000,
          closeButton: false,
        });

      } else {
        console.error("Error deleting cart.");
      }

      // await getUserPortfolio(); // refresh from server
      setIsChangeRequest(false);
    } catch (err) {
      console.error("Save failed", err);
    }

    setIsRequesting(false);
    setIsShowDetails(false);
    setIsRequestError(false);

  };

  // Cancel Changes
  const cancelSave = () => {
    setIsRequestError(false);
    if (!selectedPortfolio) return;

    // Case 1: New unsaved portfolio → remove it completely
    if (selectedPortfolio.isNew) {
      setPortfolios(prev =>
        prev.filter(p => p.id !== selectedPortfolio.id)
      );
      setSelectedPortfolio(null);
      setIsShowDetails(false);
      setIsChangeRequest(false);
      setIsCancelActive(false);
      return;
    }

    // Case 2: Existing portfolio → revert changes
    const original = portfolios.find(
      p => p.id === selectedPortfolio.id
    );

    if (original) {
      setSelectedPortfolio({ ...original });
    }

    setIsChangeRequest(false);
    setIsCancelActive(false);
    setIsShowDetails(true)
  };

  const handlePortfolioNameChange = (value) => {
    const trimmedValue = value.trim();

    setSelectedPortfolio(prev => {
      const updated = {
        ...prev,
        name: value
      };

      const original = initialPortfolios.find(
        p => p.id === updated.id
      );

      // Duplicate check (ignore self when editing)
      const isDuplicate = initialPortfolios.some(p =>
        p.id !== prev.id &&
        p.name?.trim().toLowerCase() === trimmedValue.toLowerCase()
      );
      setNameError(isDuplicate)

      console.log("isDuplicate", isDuplicate)

      if (!original) {
        // New portfolio
        setIsChangeRequest(true);
      }
      else {
        const changed = original.name !== updated.name || JSON.stringify(original.hotelIds) !== JSON.stringify(updated.hotelIds);
        setIsChangeRequest(changed);
      }

      if (isDuplicate) {
        setIsChangeRequest(false);
      }

      if (!trimmedValue || selectedPortfolio?.hotelIds.length < 2) {
        setIsChangeRequest(false);
      }
      return updated;
    });
  };


  const emptyHotelListLeft = (
    <Box className="empty-hotel-list">
      <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.8008 23.0115H29.7387V5.22988C29.7387 4.95247 29.6268 4.68642 29.4276 4.49026C29.2284 4.2941 28.9583 4.1839 28.6766 4.1839H23.3661V1.04598C23.3661 0.768565 23.2542 0.502518 23.055 0.306359C22.8558 0.110201 22.5857 0 22.304 0H9.55886C9.27717 0 9.00703 0.110201 8.80785 0.306359C8.60866 0.502518 8.49676 0.768565 8.49676 1.04598V8.3678H3.18629C2.9046 8.3678 2.63445 8.478 2.43527 8.67416C2.23609 8.87032 2.12419 9.13637 2.12419 9.41378V23.0115H1.0621C0.78041 23.0115 0.510262 23.1217 0.311081 23.3178C0.111899 23.514 0 23.78 0 24.0574C0 24.3348 0.111899 24.6009 0.311081 24.7971C0.510262 24.9932 0.78041 25.1034 1.0621 25.1034H30.8008C31.0825 25.1034 31.3526 24.9932 31.5518 24.7971C31.751 24.6009 31.8629 24.3348 31.8629 24.0574C31.8629 23.78 31.751 23.514 31.5518 23.3178C31.3526 23.1217 31.0825 23.0115 30.8008 23.0115ZM4.24838 10.4598H9.55886C9.84054 10.4598 10.1107 10.3496 10.3099 10.1534C10.5091 9.95724 10.621 9.69119 10.621 9.41378V2.09195H21.2419V5.22988C21.2419 5.50729 21.3538 5.77333 21.553 5.96949C21.7522 6.16565 22.0223 6.27585 22.304 6.27585H27.6145V23.0115H19.1177V17.7816C19.1177 17.5042 19.0058 17.2381 18.8066 17.042C18.6075 16.8458 18.3373 16.7356 18.0556 16.7356H13.8072C13.5256 16.7356 13.2554 16.8458 13.0562 17.042C12.857 17.2381 12.7451 17.5042 12.7451 17.7816V23.0115H4.24838V10.4598ZM16.9935 23.0115H14.8693V18.8276H16.9935V23.0115ZM13.8072 5.22988C13.8072 4.95247 13.9191 4.68642 14.1183 4.49026C14.3175 4.2941 14.5877 4.1839 14.8693 4.1839H16.9935C17.2752 4.1839 17.5454 4.2941 17.7445 4.49026C17.9437 4.68642 18.0556 4.95247 18.0556 5.22988C18.0556 5.50729 17.9437 5.77333 17.7445 5.96949C17.5454 6.16565 17.2752 6.27585 16.9935 6.27585H14.8693C14.5877 6.27585 14.3175 6.16565 14.1183 5.96949C13.9191 5.77333 13.8072 5.50729 13.8072 5.22988ZM13.8072 9.41378C13.8072 9.13637 13.9191 8.87032 14.1183 8.67416C14.3175 8.478 14.5877 8.3678 14.8693 8.3678H16.9935C17.2752 8.3678 17.5454 8.478 17.7445 8.67416C17.9437 8.87032 18.0556 9.13637 18.0556 9.41378C18.0556 9.69119 17.9437 9.95724 17.7445 10.1534C17.5454 10.3496 17.2752 10.4598 16.9935 10.4598H14.8693C14.5877 10.4598 14.3175 10.3496 14.1183 10.1534C13.9191 9.95724 13.8072 9.69119 13.8072 9.41378ZM21.2419 9.41378C21.2419 9.13637 21.3538 8.87032 21.553 8.67416C21.7522 8.478 22.0223 8.3678 22.304 8.3678H24.4282C24.7099 8.3678 24.98 8.478 25.1792 8.67416C25.3784 8.87032 25.4903 9.13637 25.4903 9.41378C25.4903 9.69119 25.3784 9.95724 25.1792 10.1534C24.98 10.3496 24.7099 10.4598 24.4282 10.4598H22.304C22.0223 10.4598 21.7522 10.3496 21.553 10.1534C21.3538 9.95724 21.2419 9.69119 21.2419 9.41378ZM10.621 13.5977C10.621 13.8751 10.5091 14.1411 10.3099 14.3373C10.1107 14.5335 9.84054 14.6437 9.55886 14.6437H7.43467C7.15298 14.6437 6.88284 14.5335 6.68365 14.3373C6.48447 14.1411 6.37257 13.8751 6.37257 13.5977C6.37257 13.3203 6.48447 13.0542 6.68365 12.8581C6.88284 12.6619 7.15298 12.5517 7.43467 12.5517H9.55886C9.84054 12.5517 10.1107 12.6619 10.3099 12.8581C10.5091 13.0542 10.621 13.3203 10.621 13.5977ZM10.621 17.7816C10.621 18.059 10.5091 18.325 10.3099 18.5212C10.1107 18.7174 9.84054 18.8276 9.55886 18.8276H7.43467C7.15298 18.8276 6.88284 18.7174 6.68365 18.5212C6.48447 18.325 6.37257 18.059 6.37257 17.7816C6.37257 17.5042 6.48447 17.2381 6.68365 17.042C6.88284 16.8458 7.15298 16.7356 7.43467 16.7356H9.55886C9.84054 16.7356 10.1107 16.8458 10.3099 17.042C10.5091 17.2381 10.621 17.5042 10.621 17.7816ZM13.8072 13.5977C13.8072 13.3203 13.9191 13.0542 14.1183 12.8581C14.3175 12.6619 14.5877 12.5517 14.8693 12.5517H16.9935C17.2752 12.5517 17.5454 12.6619 17.7445 12.8581C17.9437 13.0542 18.0556 13.3203 18.0556 13.5977C18.0556 13.8751 17.9437 14.1411 17.7445 14.3373C17.5454 14.5335 17.2752 14.6437 16.9935 14.6437H14.8693C14.5877 14.6437 14.3175 14.5335 14.1183 14.3373C13.9191 14.1411 13.8072 13.8751 13.8072 13.5977ZM21.2419 13.5977C21.2419 13.3203 21.3538 13.0542 21.553 12.8581C21.7522 12.6619 22.0223 12.5517 22.304 12.5517H24.4282C24.7099 12.5517 24.98 12.6619 25.1792 12.8581C25.3784 13.0542 25.4903 13.3203 25.4903 13.5977C25.4903 13.8751 25.3784 14.1411 25.1792 14.3373C24.98 14.5335 24.7099 14.6437 24.4282 14.6437H22.304C22.0223 14.6437 21.7522 14.5335 21.553 14.3373C21.3538 14.1411 21.2419 13.8751 21.2419 13.5977ZM21.2419 17.7816C21.2419 17.5042 21.3538 17.2381 21.553 17.042C21.7522 16.8458 22.0223 16.7356 22.304 16.7356H24.4282C24.7099 16.7356 24.98 16.8458 25.1792 17.042C25.3784 17.2381 25.4903 17.5042 25.4903 17.7816C25.4903 18.059 25.3784 18.325 25.1792 18.5212C24.98 18.7174 24.7099 18.8276 24.4282 18.8276H22.304C22.0223 18.8276 21.7522 18.7174 21.553 18.5212C21.3538 18.325 21.2419 18.059 21.2419 17.7816Z" fill="#606060" />
      </svg>
      <Box className="text-msg">
        <div>You Don't Have Any Available Hotels</div>
      </Box>
    </Box>
  )

  const emptyHotelListRight = (
    <Box className="empty-hotel-list">
      <svg width="39" height="28" viewBox="0 0 39 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.8008 23.0115H29.7387V5.22988C29.7387 4.95247 29.6268 4.68642 29.4276 4.49026C29.2284 4.2941 28.9583 4.1839 28.6766 4.1839H23.3661V1.04598C23.3661 0.768565 23.2542 0.502518 23.055 0.306359C22.8558 0.110201 22.5857 0 22.304 0H9.55886C9.27717 0 9.00703 0.110201 8.80785 0.306359C8.60866 0.502518 8.49676 0.768565 8.49676 1.04598V8.3678H3.18629C2.9046 8.3678 2.63445 8.478 2.43527 8.67416C2.23609 8.87032 2.12419 9.13637 2.12419 9.41378V23.0115H1.0621C0.78041 23.0115 0.510262 23.1217 0.311081 23.3178C0.111899 23.514 0 23.78 0 24.0574C0 24.3348 0.111899 24.6009 0.311081 24.7971C0.510262 24.9932 0.78041 25.1034 1.0621 25.1034H30.8008C31.0825 25.1034 31.3526 24.9932 31.5518 24.7971C31.751 24.6009 31.8629 24.3348 31.8629 24.0574C31.8629 23.78 31.751 23.514 31.5518 23.3178C31.3526 23.1217 31.0825 23.0115 30.8008 23.0115ZM4.24838 10.4598H9.55886C9.84054 10.4598 10.1107 10.3496 10.3099 10.1534C10.5091 9.95724 10.621 9.69119 10.621 9.41378V2.09195H21.2419V5.22988C21.2419 5.50729 21.3538 5.77333 21.553 5.96949C21.7522 6.16565 22.0223 6.27585 22.304 6.27585H27.6145V23.0115H19.1177V17.7816C19.1177 17.5042 19.0058 17.2381 18.8066 17.042C18.6075 16.8458 18.3373 16.7356 18.0556 16.7356H13.8072C13.5256 16.7356 13.2554 16.8458 13.0562 17.042C12.857 17.2381 12.7451 17.5042 12.7451 17.7816V23.0115H4.24838V10.4598ZM16.9935 23.0115H14.8693V18.8276H16.9935V23.0115ZM13.8072 5.22988C13.8072 4.95247 13.9191 4.68642 14.1183 4.49026C14.3175 4.2941 14.5877 4.1839 14.8693 4.1839H16.9935C17.2752 4.1839 17.5454 4.2941 17.7445 4.49026C17.9437 4.68642 18.0556 4.95247 18.0556 5.22988C18.0556 5.50729 17.9437 5.77333 17.7445 5.96949C17.5454 6.16565 17.2752 6.27585 16.9935 6.27585H14.8693C14.5877 6.27585 14.3175 6.16565 14.1183 5.96949C13.9191 5.77333 13.8072 5.50729 13.8072 5.22988ZM13.8072 9.41378C13.8072 9.13637 13.9191 8.87032 14.1183 8.67416C14.3175 8.478 14.5877 8.3678 14.8693 8.3678H16.9935C17.2752 8.3678 17.5454 8.478 17.7445 8.67416C17.9437 8.87032 18.0556 9.13637 18.0556 9.41378C18.0556 9.69119 17.9437 9.95724 17.7445 10.1534C17.5454 10.3496 17.2752 10.4598 16.9935 10.4598H14.8693C14.5877 10.4598 14.3175 10.3496 14.1183 10.1534C13.9191 9.95724 13.8072 9.69119 13.8072 9.41378ZM21.2419 9.41378C21.2419 9.13637 21.3538 8.87032 21.553 8.67416C21.7522 8.478 22.0223 8.3678 22.304 8.3678H24.4282C24.7099 8.3678 24.98 8.478 25.1792 8.67416C25.3784 8.87032 25.4903 9.13637 25.4903 9.41378C25.4903 9.69119 25.3784 9.95724 25.1792 10.1534C24.98 10.3496 24.7099 10.4598 24.4282 10.4598H22.304C22.0223 10.4598 21.7522 10.3496 21.553 10.1534C21.3538 9.95724 21.2419 9.69119 21.2419 9.41378ZM10.621 13.5977C10.621 13.8751 10.5091 14.1411 10.3099 14.3373C10.1107 14.5335 9.84054 14.6437 9.55886 14.6437H7.43467C7.15298 14.6437 6.88284 14.5335 6.68365 14.3373C6.48447 14.1411 6.37257 13.8751 6.37257 13.5977C6.37257 13.3203 6.48447 13.0542 6.68365 12.8581C6.88284 12.6619 7.15298 12.5517 7.43467 12.5517H9.55886C9.84054 12.5517 10.1107 12.6619 10.3099 12.8581C10.5091 13.0542 10.621 13.3203 10.621 13.5977ZM10.621 17.7816C10.621 18.059 10.5091 18.325 10.3099 18.5212C10.1107 18.7174 9.84054 18.8276 9.55886 18.8276H7.43467C7.15298 18.8276 6.88284 18.7174 6.68365 18.5212C6.48447 18.325 6.37257 18.059 6.37257 17.7816C6.37257 17.5042 6.48447 17.2381 6.68365 17.042C6.88284 16.8458 7.15298 16.7356 7.43467 16.7356H9.55886C9.84054 16.7356 10.1107 16.8458 10.3099 17.042C10.5091 17.2381 10.621 17.5042 10.621 17.7816ZM13.8072 13.5977C13.8072 13.3203 13.9191 13.0542 14.1183 12.8581C14.3175 12.6619 14.5877 12.5517 14.8693 12.5517H16.9935C17.2752 12.5517 17.5454 12.6619 17.7445 12.8581C17.9437 13.0542 18.0556 13.3203 18.0556 13.5977C18.0556 13.8751 17.9437 14.1411 17.7445 14.3373C17.5454 14.5335 17.2752 14.6437 16.9935 14.6437H14.8693C14.5877 14.6437 14.3175 14.5335 14.1183 14.3373C13.9191 14.1411 13.8072 13.8751 13.8072 13.5977ZM21.2419 13.5977C21.2419 13.3203 21.3538 13.0542 21.553 12.8581C21.7522 12.6619 22.0223 12.5517 22.304 12.5517H24.4282C24.7099 12.5517 24.98 12.6619 25.1792 12.8581C25.3784 13.0542 25.4903 13.3203 25.4903 13.5977C25.4903 13.8751 25.3784 14.1411 25.1792 14.3373C24.98 14.5335 24.7099 14.6437 24.4282 14.6437H22.304C22.0223 14.6437 21.7522 14.5335 21.553 14.3373C21.3538 14.1411 21.2419 13.8751 21.2419 13.5977ZM21.2419 17.7816C21.2419 17.5042 21.3538 17.2381 21.553 17.042C21.7522 16.8458 22.0223 16.7356 22.304 16.7356H24.4282C24.7099 16.7356 24.98 16.8458 25.1792 17.042C25.3784 17.2381 25.4903 17.5042 25.4903 17.7816C25.4903 18.059 25.3784 18.325 25.1792 18.5212C24.98 18.7174 24.7099 18.8276 24.4282 18.8276H22.304C22.0223 18.8276 21.7522 18.7174 21.553 18.5212C21.3538 18.325 21.2419 18.059 21.2419 17.7816Z" fill="#606060" />
        <ellipse cx="30.8973" cy="20.7589" rx="7.24156" ry="7.24137" fill="white" />
        <path d="M30.8974 14.4824C29.6561 14.4824 28.4427 14.8505 27.4106 15.5401C26.3785 16.2297 25.5741 17.2098 25.0991 18.3566C24.6241 19.5034 24.4998 20.7652 24.7419 21.9826C24.9841 23.2 25.5818 24.3183 26.4595 25.196C27.3373 26.0737 28.4555 26.6714 29.673 26.9135C30.8904 27.1557 32.1523 27.0314 33.2991 26.5564C34.4459 26.0814 35.4261 25.277 36.1157 24.245C36.8053 23.2129 37.1734 21.9995 37.1734 20.7583C37.1713 19.0945 36.5094 17.4994 35.3329 16.3229C34.1564 15.1464 32.5612 14.4845 30.8974 14.4824ZM33.3112 21.241H31.3801V23.1721C31.3801 23.3001 31.3293 23.4229 31.2387 23.5134C31.1482 23.604 31.0254 23.6548 30.8974 23.6548C30.7693 23.6548 30.6465 23.604 30.556 23.5134C30.4655 23.4229 30.4146 23.3001 30.4146 23.1721V21.241H28.4835C28.3555 21.241 28.2327 21.1902 28.1421 21.0996C28.0516 21.0091 28.0007 20.8863 28.0007 20.7583C28.0007 20.6302 28.0516 20.5074 28.1421 20.4169C28.2327 20.3264 28.3555 20.2755 28.4835 20.2755H30.4146V18.3445C30.4146 18.2164 30.4655 18.0937 30.556 18.0031C30.6465 17.9126 30.7693 17.8617 30.8974 17.8617C31.0254 17.8617 31.1482 17.9126 31.2387 18.0031C31.3293 18.0937 31.3801 18.2164 31.3801 18.3445V20.2755H33.3112C33.4393 20.2755 33.562 20.3264 33.6526 20.4169C33.7431 20.5074 33.794 20.6302 33.794 20.7583C33.794 20.8863 33.7431 21.0091 33.6526 21.0996C33.562 21.1902 33.4393 21.241 33.3112 21.241Z" fill="#606060" />
      </svg>
      <Box className="text-msg">
        <div>Please Add at Least Two Hotels to</div>
        <div>Create a Portfolio</div>
      </Box>
    </Box>
  )

  const setDefaultCheckedIcon = (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9343 5.40524L9.47334 7.52875L10.2231 10.7045C10.2645 10.8769 10.2538 11.0576 10.1925 11.224C10.1312 11.3903 10.0219 11.5348 9.87855 11.639C9.73517 11.7433 9.56411 11.8028 9.38696 11.8099C9.20982 11.817 9.03454 11.7714 8.88327 11.679L6.12155 9.9793L3.35819 11.679C3.20694 11.7709 3.03187 11.816 2.85503 11.8087C2.67819 11.8013 2.50748 11.7418 2.36441 11.6376C2.22133 11.5334 2.11229 11.3892 2.051 11.2231C1.98971 11.0571 1.97892 10.8766 2.01999 10.7045L2.77249 7.52875L0.311548 5.40524C0.177727 5.28958 0.0809444 5.13706 0.0332884 4.96672C-0.0143677 4.79639 -0.0107855 4.61579 0.0435874 4.44748C0.0979604 4.27917 0.200714 4.1306 0.339017 4.02034C0.477319 3.91008 0.645041 3.84301 0.821236 3.8275L4.0478 3.56719L5.29249 0.555002C5.35986 0.39084 5.47452 0.250419 5.62191 0.151593C5.76929 0.0527673 5.94273 0 6.12018 0C6.29763 0 6.47107 0.0527673 6.61845 0.151593C6.76584 0.250419 6.8805 0.39084 6.94788 0.555002L8.19202 3.56719L11.4186 3.8275C11.5951 3.84243 11.7633 3.90913 11.9021 4.01924C12.0409 4.12935 12.1442 4.27797 12.1989 4.44649C12.2536 4.615 12.2574 4.79591 12.2097 4.96656C12.1621 5.13721 12.0651 5.28999 11.931 5.40578L11.9343 5.40524Z" fill="#FAB005" />
    </svg>
  );
  const setDefaultUncheckedIcon = (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9343 5.40524L9.47334 7.52875L10.2231 10.7045C10.2645 10.8769 10.2538 11.0576 10.1925 11.224C10.1312 11.3903 10.0219 11.5348 9.87855 11.639C9.73517 11.7433 9.56411 11.8028 9.38696 11.8099C9.20982 11.817 9.03454 11.7714 8.88327 11.679L6.12155 9.9793L3.35819 11.679C3.20694 11.7709 3.03187 11.816 2.85503 11.8087C2.67819 11.8013 2.50748 11.7418 2.36441 11.6376C2.22133 11.5334 2.11229 11.3892 2.051 11.2231C1.98971 11.0571 1.97892 10.8766 2.01999 10.7045L2.77249 7.52875L0.311548 5.40524C0.177727 5.28958 0.0809444 5.13706 0.0332884 4.96672C-0.0143677 4.79639 -0.0107855 4.61579 0.0435874 4.44748C0.0979604 4.27917 0.200714 4.1306 0.339017 4.02034C0.477319 3.91008 0.645041 3.84301 0.821236 3.8275L4.0478 3.56719L5.29249 0.555002C5.35986 0.39084 5.47452 0.250419 5.62191 0.151593C5.76929 0.0527673 5.94273 0 6.12018 0C6.29763 0 6.47107 0.0527673 6.61845 0.151593C6.76584 0.250419 6.8805 0.39084 6.94788 0.555002L8.19202 3.56719L11.4186 3.8275C11.5951 3.84243 11.7633 3.90913 11.9021 4.01924C12.0409 4.12935 12.1442 4.27797 12.1989 4.44649C12.2536 4.615 12.2574 4.79591 12.2097 4.96656C12.1621 5.13721 12.0651 5.28999 11.931 5.40578L11.9343 5.40524Z" fill="#B2B2B2" />
    </svg>
  );

  // Stop loading after 2 sec
  useEffect(() => {
    getUserPortfolio();

    const timer = setTimeout(() => {
      // setIsLoading(false);
    }, 2000); // 2 seconds

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   if (!selectedPortfolio || !initialPortfolios) return;

  //   const changed = hasPortfolioChanged(initialPortfolios, selectedPortfolio);
  //   setIsChangeRequest(changed);
  // }, [selectedPortfolio, initialPortfolios]);


  return (
    <div className="portfolio-settings">

      <Box className='top-axn-bar-1'>
        <Tooltip title="Back to Dashboard" arrow followCursor >
          <Button
            size="medium"
            variant="contained"
            className='back-to-dash-btn'
            onClick={goBackToDashboard}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="16.001" viewBox="0 0 16.001 16.001">
              <g id="Group_2234" data-name="Group 2234" transform="translate(24154 19449)">
                <path id="Path_3278" data-name="Path 3278" d="M.889,0h8.3a.889.889,0,0,1,.889.889V9.482a.889.889,0,0,1-.889.889H.889A.889.889,0,0,1,0,9.482V.889A.889.889,0,0,1,.889,0Z" transform="translate(-24154 -19449)" fill="#606060" />
                <g id="Path_3279" data-name="Path 3279" transform="translate(-24142.74 -19449)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3280" data-name="Path 3280" transform="translate(-24142.74 -19443.371)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3283" data-name="Path 3283" transform="translate(-24142.74 -19437.74)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3281" data-name="Path 3281" transform="translate(-24154 -19437.74)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
                <g id="Path_3282" data-name="Path 3282" transform="translate(-24148.369 -19437.74)" fill="#333">
                  <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                  <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                </g>
              </g>
            </svg>
            <span className='back-to-dash-txt'>Back to Dashboard</span>
          </Button>
        </Tooltip>

        {isShowDetails && (<Box className={(isShakeButton) ? "top-axn-bar-1-sub bt-shake" : "top-axn-bar-1-sub"}>
          {refreshDataBtnAccess.includes(user_login_type) &&
            <Tooltip title="Refresh Data" >
              <box
                onClick={refreshData}
                size="medium"
                variant="contained"
                className='refresh-btn'
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="#00415F" viewBox="0 0 256 256"><path d="M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z"></path></svg>
              </box>
            </Tooltip>
          }

          <Button
            disabled={!isChangeRequest && !isCancelActive}
            onClick={cancelSave}
            variant="outlined"
            className={(isChangeRequest || isCancelActive) ? "navigate-cancel-button btn-active" : "navigate-cancel-button"}
            // color="error"
            size="small"
            sx={{ minWidth: "auto" }}
          >
            cancel
          </Button>

          <Button
            disabled={!isChangeRequest}
            onClick={() => {
              saveChanges();
            }}
            variant="outlined"
            size="small"
            className={(isChangeRequest) ? "navigate-save-button btn-active" : "navigate-save-button"}
            // color="green"
            sx={{ minWidth: "auto", mr: 1, color: "white.main" }}
          >
            <span style={{ display: !isrequesting ? "block" : "none" }}>
              Save
            </span>
            <span
              style={{
                display: isrequesting ? "block" : "none",
                paddingRight: 10,
              }}
            >
              saving...
            </span>
            <CircularProgress
              sx={{ display: isrequesting ? "block" : "none" }}
              color="white"
              size="16px"
            />
          </Button>
        </Box>)}

        <Alert
          icon={false}
          sx={{
            display: refreshedData ? "block" : "none",
            position: "fixed",
            left: 0,
            fontSize: 17,
            textAlign: "center",
            borderRadius: 0,
            lineHeight: 1,
            bottom: 40,
            width: "100%",
            zIndex: 100,
            backgroundColor: "green.main",
            color: "white.main",
          }}
          severity="success"
        >
          Data refreshed successfully!
        </Alert>

      </Box>

      <Box className='top-axn-bar'>
        <Box className='breadcrumb' sx={{ color: 'white.main' }}>
          <span className="breadcrum-inactive">Settings/</span>
          <span className="breadcrum-inactive">Profile Settings/</span>
          <span className="breadcrum-active">Portfolios</span>
        </Box>
      </Box>

      <Alert severity="error"
        sx={{
          mt: 1,
          mb: 1,
          mr: 2,
          ml: 2,
          display: isRequestError ? "flex" : "none",
        }}
      >
        Please save your changes to continue.
      </Alert>

      {/* Portfolio cards main page */}
      <Box className="bgwhite main-scroll-wrap" sx={{ p: 2, pt: 0 }}>

        {/* Portfolio Details Page */}
        {isShowDetails && !isReadOnlyDetails &&
          <PortfolioDetailsPage
            selectedPortfolio={selectedPortfolio}
            availableHotels={availableHotels}
            selectedHotels={selectedHotels}
            checkedLeft={checkedLeft}
            checkedRight={checkedRight}
            hotelsData={hotelsData}
            emptyHotelListLeft={emptyHotelListLeft}
            emptyHotelListRight={emptyHotelListRight}
            handleBackButton={handleBackButton}
            handleSelectAllLeft={handleSelectAllLeft}
            handleSelectAllRight={handleSelectAllRight}
            handleLeftCheck={handleLeftCheck}
            handleRightCheck={handleRightCheck}
            handleAdd={handleAdd}
            handleRemove={handleRemove}
            unCheckedIcon={unCheckedIcon}
            checkedIcon={checkedIcon}
            handlePortfolioNameChange={handlePortfolioNameChange}
            nameError={nameError}
          />
        }

        {/* Portfolio Details Read Only Page */}
        {isShowDetails && isReadOnlyDetails &&
          <PortfolioDetailsReadOnlyPage
            hotelsData={hotelsData}
            handleBackButton={handleBackButton}
          />
        }

        {/* Portfolio Home Page */}
        {!isShowDetails &&
          <PortfolioHomePage
            portfolios={portfolios}
            isLoading={isLoading}
            handleCardClick={handleCardClick}
            handleDeletePortfolio={handleDeletePortfolio}
            handleAddNewPortfolio={handleAddNewPortfolio}
            setDefaultCheckedIcon={setDefaultCheckedIcon}
            setDefaultUncheckedIcon={setDefaultUncheckedIcon}
            handleDefaultPortfolio={handleDefaultPortfolio}
            maxPortfolioLimit={maxPortfolioLimit}
          />
        }

        {/* Portfolio delete popup */}
        <PortfolioDeleteModal
          showDeletePopup={showDeletePopup}
          closeDeletePopup={closeDeletePopup}
          confirmDeletePortfolio={confirmDeletePortfolio}
          portfolioId={selectedPortfolioDeleteId}
          portfolios={portfolios}
        />

        {/* Portfolio limit reached popup */}
        <PortfolioLimitReachedModal
          showLimitReachedPopup={showLimitReachedPopup}
          closeLimitReachedPopup={closeLimitReachedPopup}
          maxPortfolioLimit={maxPortfolioLimit}
          portfolios={portfolios}
          openRequestSupport={openRequestSupport}
        //handleContactSupport={handleContactSupport}
        />

        {refreshingData && (
          <Box
            sx={{
              textAlighn: "center",
              backgroundColor: "dark.darkest",
              opacity: 0.8,
              position: "fixed",
              top: 40,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 100,
            }}
          >
            <CircularProgress
              size={40}
              sx={{
                color: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-20px",
                marginLeft: "-20px",
              }}
            />
          </Box>
        )}

      </Box >

    </div >
  );
}



export { ProfileSettings, SecuritySettings, PortfolioSettings };